/* eslint-disable react-hooks/exhaustive-deps */

import englishMessages from "jazasoft/lib/i18n/default-messages/js-language-english";

const messages = {
  ...englishMessages,
  app_name_short: "IAM",
  app_name_full: "Identity and Access Management",
  dashboard: "Dashboard",
  resources: {
    users: {
      name: "User |||| Users",
      fields: {
        firstName: "First Name",
        lastName: "Last Name",
        username: "Username",
        email: "Email",
        password: "Password",
        mobile: "Mobile",
        tenantId: "Tenant",
        roleIds: "Roles",
        appIds: "Apps",
      },
    },
    roles: {
      name: "Role |||| Roles",
      fields: {
        name: "Role Name",
        roleId: "Role Id",
        desc: "Description",
      },
    },
    resources: {
      name: "API",
      fields: {
        resourceId: "API Id",
        name: "API Name",
        actions: "Operations",
        desc: "Description",
      },
    },
    permissions: {
      name: "Permission |||| Permissions",
      fields: {
        name: "Name",
        key: "Permission Key",
      },
    },
    apps: {
      name: "App |||| Apps",
      fields: {
        appName: "App Name",
        appId: "App Id",
        appPrefix: "App Prefix",
        desc: "Description",
        endpoint: "EndPoint",
      },
    },
    tenants: {
      name: "Tenant |||| Tenants",
      fields: {
        name: "Name",
        tenantId: "Tenant Id",
        address: "Address",
        desc: "Description",
      },
    },
  },
};

export default messages;
